// ============================================
// Path: /frontend/src/api/inquiries.api.js
// Purpose: Inquiries API endpoints for listing inquiries
// ============================================

import apiClient from './client.js';

export const inquiriesAPI = {
  // Get all inquiries (admin only)
  getAllInquiries: async () => {
    console.log('[inquiriesAPI] Fetching all inquiries (admin)');
    try {
      const response = await apiClient.get('/inquiries');
      console.log('[inquiriesAPI] Fetched', response.data.inquiries?.length || 0, 'inquiries');
      return response.data;
    } catch (error) {
      console.error('[inquiriesAPI] Error fetching inquiries:', error);
      throw error;
    }
  },

  // Get user's inquiries
  getUserInquiries: async (userId) => {
    console.log('[inquiriesAPI] Fetching inquiries for user:', userId);
    try {
      const response = await apiClient.get(`/inquiries/user/${userId}`);
      console.log('[inquiriesAPI] Fetched', response.data.inquiries?.length || 0, 'user inquiries');
      return response.data;
    } catch (error) {
      console.error('[inquiriesAPI] Error fetching user inquiries:', error);
      throw error;
    }
  },

  // Create new inquiry
  createInquiry: async (inquiryData) => {
    console.log('[inquiriesAPI] Creating inquiry:', inquiryData);
    try {
      const response = await apiClient.post('/inquiries', inquiryData);
      console.log('[inquiriesAPI] Inquiry created successfully:', response.data.inquiry?.id);
      return response.data;
    } catch (error) {
      console.error('[inquiriesAPI] Error creating inquiry:', error);
      throw error;
    }
  },

  // Reply to inquiry (seller only)
  replyToInquiry: async (inquiryId, reply) => {
    console.log('[inquiriesAPI] Replying to inquiry:', inquiryId);
    try {
      const response = await apiClient.put(`/inquiries/${inquiryId}/reply`, { reply });
      console.log('[inquiriesAPI] Reply sent successfully');
      return response.data;
    } catch (error) {
      console.error('[inquiriesAPI] Error replying to inquiry:', error);
      throw error;
    }
  },

  // Delete inquiry (admin only)
  deleteInquiry: async (id) => {
    console.log('[inquiriesAPI] Deleting inquiry:', id);
    try {
      const response = await apiClient.delete(`/inquiries/${id}`);
      console.log('[inquiriesAPI] Inquiry deleted successfully');
      return response.data;
    } catch (error) {
      console.error('[inquiriesAPI] Error deleting inquiry:', error);
      throw error;
    }
  },
};